import { routerReducer } from 'react-router-redux'

export default (state, action, megastate) => {
	if (action.type == 'NAVIGATE') {
        let pathname = '/landlord/' + action.data
        return {...state, locationBeforeTransitions: { ...state.locationBeforeTransitions, pathname }}
	}
	return routerReducer(state, action)
}



// WEBPACK FOOTER //
// ./src/reducers/routing.landlord.js